import { INPUT_TYPES, REGISTRATION_TYPES, BUILDER_TYPES } from './constants';

export const types = [
    {
        id: 0,
        name: 'header',
        type: INPUT_TYPES.HEADER,
        unique: false,
        [BUILDER_TYPES.FORM]: true,
        [BUILDER_TYPES.SUCCESS_PAGE]: true,
    },
    {
        id: 1,
        name: 'text',
        type: INPUT_TYPES.INPUT,
        unique: false,
        [BUILDER_TYPES.FORM]: true,
        [BUILDER_TYPES.SUCCESS_PAGE]: false,
    },
    {
        id: 2,
        name: 'email',
        type: INPUT_TYPES.EMAIL,
        unique: true,
        [BUILDER_TYPES.FORM]: true,
        [BUILDER_TYPES.SUCCESS_PAGE]: false,
    },
    {
        id: 3,
        name: 'toggle',
        type: INPUT_TYPES.TOGGLE,
        unique: false,
        [BUILDER_TYPES.FORM]: true,
        [BUILDER_TYPES.SUCCESS_PAGE]: false,
    },
    {
        id: 4,
        name: 'select (radio)',
        type: INPUT_TYPES.SELECT_RADIO,
        unique: false,
        [BUILDER_TYPES.FORM]: true,
        [BUILDER_TYPES.SUCCESS_PAGE]: false,
    },
    {
        id: 5,
        name: 'select',
        type: INPUT_TYPES.SELECT,
        unique: false,
        [BUILDER_TYPES.FORM]: true,
        [BUILDER_TYPES.SUCCESS_PAGE]: false,
    },
    {
        id: 23,
        name: 'select user group',
        type: INPUT_TYPES.SELECT_USER_GROUP,
        unique: false,
        [BUILDER_TYPES.FORM]: true,
        [BUILDER_TYPES.SUCCESS_PAGE]: false,
    },
    {
        id: 6,
        name: 'star rating',
        type: INPUT_TYPES.STARS_RATING,
        unique: false,
        [BUILDER_TYPES.FORM]: true,
        [BUILDER_TYPES.SUCCESS_PAGE]: false,
    },
    {
        id: 7,
        name: 'number',
        type: INPUT_TYPES.NUMBER,
        unique: false,
        [BUILDER_TYPES.FORM]: true,
        [BUILDER_TYPES.SUCCESS_PAGE]: false,
    },
    {
        id: 8,
        name: 'date',
        type: INPUT_TYPES.DATE,
        unique: false,
        [BUILDER_TYPES.FORM]: true,
        [BUILDER_TYPES.SUCCESS_PAGE]: false,
    },
    {
        id: 9,
        name: 'time',
        type: INPUT_TYPES.TIME,
        unique: false,
        [BUILDER_TYPES.FORM]: true,
        [BUILDER_TYPES.SUCCESS_PAGE]: false,
    },
    {
        id: 10,
        name: 'address',
        type: INPUT_TYPES.SHORT_ADDRESS,
        unique: false,
        [BUILDER_TYPES.FORM]: true,
        [BUILDER_TYPES.SUCCESS_PAGE]: false,
    },
    {
        id: 11,
        name: 'terms and conditions',
        type: INPUT_TYPES.TERMS,
        unique: true,
        [BUILDER_TYPES.FORM]: true,
        [BUILDER_TYPES.SUCCESS_PAGE]: false,
    },
    {
        id: 12,
        name: 'label',
        type: INPUT_TYPES.LABEL,
        unique: false,
        [BUILDER_TYPES.FORM]: true,
        [BUILDER_TYPES.SUCCESS_PAGE]: false,
    },
    {
        id: 13,
        name: 'section break',
        type: INPUT_TYPES.SECTION_BREAK,
        unique: false,
        [BUILDER_TYPES.FORM]: true,
        [BUILDER_TYPES.SUCCESS_PAGE]: true,
    },
    {
        id: 14,
        name: 'file picker',
        type: INPUT_TYPES.FILE_PICKER,
        unique: true,
        [BUILDER_TYPES.FORM]: true,
        [BUILDER_TYPES.SUCCESS_PAGE]: false,
    },
    {
        id: 15,
        name: 'password',
        type: INPUT_TYPES.PASSWORD,
        unique: true,
        [BUILDER_TYPES.FORM]: true,
        [BUILDER_TYPES.SUCCESS_PAGE]: false,
    },
    {
        id: 16,
        name: 'registration',
        type: INPUT_TYPES.REGISTRATION,
        unique: false,
        [BUILDER_TYPES.FORM]: true,
        [BUILDER_TYPES.SUCCESS_PAGE]: false,
    },
    {
        id: 17,
        name: 'description',
        type: INPUT_TYPES.DESCRIPTION,
        unique: false,
        [BUILDER_TYPES.FORM]: true,
        [BUILDER_TYPES.SUCCESS_PAGE]: true,
    },
    {
        id: 18,
        name: 'html',
        type: INPUT_TYPES.HTML,
        unique: false,
        [BUILDER_TYPES.FORM]: true,
        [BUILDER_TYPES.SUCCESS_PAGE]: true,
    },
    {
        id: 19,
        name: 'submit button',
        type: INPUT_TYPES.SUBMIT_BUTTON,
        unique: true,
        [BUILDER_TYPES.FORM]: true,
        [BUILDER_TYPES.SUCCESS_PAGE]: false,
    },
    {
        id: 20,
        name: 'button',
        type: INPUT_TYPES.BUTTON,
        unique: false,
        [BUILDER_TYPES.FORM]: true,
        [BUILDER_TYPES.SUCCESS_PAGE]: false,
    },
    {
        id: 21,
        name: 'image',
        type: INPUT_TYPES.IMAGE,
        unique: false,
        [BUILDER_TYPES.FORM]: true,
        [BUILDER_TYPES.SUCCESS_PAGE]: true,
    },
    {
        id: 22,
        name: 'add to calendar',
        type: INPUT_TYPES.ADD_TO_CALENDAR,
        unique: false,
        [BUILDER_TYPES.FORM]: false,
        [BUILDER_TYPES.SUCCESS_PAGE]: true,
    },
    {
        id: 24,
        name: 'java script',
        type: INPUT_TYPES.JAVA_SCRIPT,
        unique: false,
        [BUILDER_TYPES.FORM]: true,
        [BUILDER_TYPES.SUCCESS_PAGE]: true,
    },

];

export const registrationTypes = [
    {
        id: 1,
        value: REGISTRATION_TYPES.TITLE,
        label: 'Title'
    },
    {
        id: 2,
        value: REGISTRATION_TYPES.FIRST_NAME,
        label: 'First Name'
    },
    {
        id: 3,
        value: REGISTRATION_TYPES.LAST_NAME,
        label: 'Last Name'
    },
    {
        id: 4,
        value: REGISTRATION_TYPES.ADDRESS_LINE_1,
        label: 'Address Line 1'
    },
    {
        id: 5,
        value: REGISTRATION_TYPES.ADDRESS_LINE_2,
        label: 'Address Line 2'
    },
    {
        id: 6,
        value: REGISTRATION_TYPES.TOWN,
        label: 'Town'
    },
    {
        id: 7,
        value: REGISTRATION_TYPES.REGION,
        label: 'Region'
    },
    {
        id: 8,
        value: REGISTRATION_TYPES.COUNTRY,
        label: 'Country'
    },
    {
        id: 9,
        value: REGISTRATION_TYPES.POSTCODE,
        label: 'Postcode'
    },
    {
        id: 10,
        value: REGISTRATION_TYPES.COMPANY,
        label: 'Company'
    },
    {
        id: 11,
        value: REGISTRATION_TYPES.POSITION,
        label: 'Position'
    },
    {
        id: 12,
        value: REGISTRATION_TYPES.WORK_TEL,
        label: 'Work Tel'
    },
    {
        id: 13,
        value: REGISTRATION_TYPES.HOME_TEL,
        label: 'Home Tel'
    },
    {
        id: 14,
        value: REGISTRATION_TYPES.MOBILE_TEL,
        label: 'Mobile Tel'
    },
];
